export default __webpack_public_path__ + "static/media/regulatory--axle-limit--g1.8eb43884.png";